import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=59a6fb1f&scoped=true&lang=pug"
import script from "./help-center.vue?vue&type=script&lang=ts"
export * from "./help-center.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a6fb1f",
  null
  
)

export default component.exports